export class EnableTwoFactorResponse {
  expires_in: number;
  qr_code: string;
  token: string;
}

export class VerifyTwoFactorResponse {
  recovery_codes: string[];
}
